import React from 'react';
import styles from './FullWidthHighlightSection.module.scss';

interface Props {
  children: React.ReactNode;
  isFooter?: boolean;
}

const FullWidthHighlightSection: React.FC<Props> = ({ children, isFooter = false }) => {
  return (
    <div className={`${styles.container} ${isFooter ? styles.footer : ''}`}>
      <div className={styles.background} />
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default FullWidthHighlightSection;
